module.exports = __webpack_public_path__ + "static/media/x.1d3fbd30.svg";